import ProgramExplorer from './ProgramExplorer';

const PROGRAMS = [
  {
    icon: 'workshop',
    title: 'Public Speaking & Presentation Confidence',
    desc: 'Individual coaching to speak and present with clarity, structure and genuine confidence.',
    tags: ['Stage presence', 'Delivery', 'Confidence'],
  },
  {
    icon: 'role-play',
    title: 'Executive Presence & Personal Branding',
    desc: 'Shape how you show up: the presence, voice and personal brand that set senior professionals apart.',
    tags: ['Personal brand', 'Gravitas', 'Influence'],
  },
  {
    icon: 'coaching',
    title: 'Communication & Workplace Confidence Coaching',
    desc: 'Coaching to communicate assertively, handle pressure and show up with confidence at work.',
    tags: ['Assertiveness', 'Clarity', 'Composure'],
  },
  {
    icon: 'bar-growth',
    title: 'Leadership Growth for New Managers',
    desc: 'Support for first-time managers stepping into leadership, from managing peers to leading with confidence.',
    tags: ['New managers', 'People skills', 'Delegation'],
  },
];

export default function ForIndividuals() {
  return (
    <ProgramExplorer
      id="for-individuals"
      variant="light"
      eyebrow="PERSONAL COACHING & DEVELOPMENT"
      title="For Individuals"
      intro="Individual coaching for professionals who want to communicate with confidence, build executive presence and grow into leadership roles."
      programs={PROGRAMS}
      ctaText="Book a personal session"
      ctaClass="btn-dark"
    />
  );
}
